import * as actionTypes from './actionTypes';

import { createActionObject } from '../../helpers/common';

import * as strings from '../../helpers/strings';

export const setEmail = email => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_EMAIL,
    { 
      email,
      emailError: email ? "" : strings.msgEmailRequired
    }
  )
)

export const setPassword = password => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_PASSWORD,
    { 
      password,
      passwordError: password ? "" : strings.msgPasswordRequired
    }
  )
)